import { render } from "./ProductItemPhotosField.vue?vue&type=template&id=41fc7b29"
import script from "./ProductItemPhotosField.vue?vue&type=script&lang=js"
export * from "./ProductItemPhotosField.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./ProductItemPhotosField.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild_9bf761c1%2Fpackages%2Fcustomer%2Fsrc%2Fviews%2Fplan%2FProductItemPhotosField.vue&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__